<template>
  <div>
    <el-dialog
      :title="createOrUp == 'up' ? '会员管理' : '新建会员'"
      :visible.sync="value"
      width="40%"
      :before-close="createVipDialogClose"
      :close-on-click-modal="false"
    >
      <div class="positionR">
        <el-form
          ref="cVipform"
          :model="cVipform"
          label-width="100px"
          :rules="createOrUp == 'up' ? rulesNull : rules"
          class="width70"
        >
          <el-form-item label="会员卡号：" prop="memberCardSn">
            <el-input
              v-model="cVipform.memberCardSn"
              class="width70"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="memberName">
            <el-input
              v-model="cVipform.memberName"
              class="width70"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="memberMobile">
            <el-input
              v-model="cVipform.memberMobile"
              class="width70"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-input>
          </el-form-item>
          <el-form-item label="出生日期：" prop="memberBirthday">
            <el-date-picker
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              v-model="cVipform.memberBirthday"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="身份证号：" prop="memberSfnum">
            <el-input
              v-model="cVipform.memberSfnum"
              class="width70"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="会员等级："
            prop="levelId"
            v-if="createOrUp == 'up'"
          >
            <el-select
              clearable
              v-model="cVipform.levelId"
              placeholder="请选择会员等级"
              size="small"
            >
              <el-option
                v-for="item in mdSelectList"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="储值："
            prop="balance"
            v-if="createOrUp == 'create'"
          >
            <el-input
              v-model="cVipform.balance"
              class="width70"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="储值：" v-if="createOrUp == 'up'">
            <el-input
              v-model="upbalance"
              class="width70"
              size="small"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="赠储：" prop="giveStore">
            <el-input
              v-model="cVipform.giveStore"
              class="width70"
              size="small"
              :disabled="createOrUp == 'up'"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </el-form-item> -->

          <el-form-item label="分组信息：" prop="memberDeptId">
            <el-select
              clearable
              v-model="cVipform.memberDeptId"
              placeholder="请选择分组信息"
              size="small"
              :disabled="createOrUp == 'up'"
            >
              <el-option
                v-for="item in groupsSelectList"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员荣誉：" prop="honourIds">
            <el-checkbox-group
              v-model="cVipform.honourIds"
              size="small"
              :disabled="createOrUp == 'up'"
            >
              <el-checkbox-button
                v-for="item in honourList"
                :label="item.id"
                :key="item.id"
                >{{ item.honourName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="会员备注：" prop="remark">
            <el-input
              type="textarea"
              v-model="cVipform.remark"
              size="small"
              :disabled="createOrUp == 'up'"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="vipManPhoto">
          <span>会员照片:</span>
          <el-upload
            class="avatar-uploader"
            accept=".png,.jpg,.jpeg,.JPG,.JPEG"
            :headers="headers"
            :action="upLoadUrl"
            :show-file-list="false"
            :on-success="creatHandleAvatarSuccess"
            :before-upload="creatBeforeAvatarUpload"
          >
            <img v-if="creatImageUrl" :src="creatImageUrl" class="avatarImport" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div v-if="createOrUp == 'up'" class="gradeNow">
        <h6>当前等级：{{ cardName }}</h6>
        <div class="vipnows">
          <div>积分：{{ cVipform.points }}</div>
          <div>储值：{{ cVipform.balance }}</div>
          <div>赠储：{{ cVipform.giveStore }}</div>
          <!-- <div>消费积分：{{ "没有字段" }}</div> -->
          <div>箭票：{{ cVipform.arrowTicket }}</div>
          <div>电子卡：{{ cVipform.electronicCard }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createVip">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMembersCardLevelSelect } from "../../api/BusinessManagement";
import {
  addMember,
  getOldDeptForSelect,
  getHonourList,
  getMemberById,
  getUpgradeCardList,
} from "@/api/OrderManagement.js";
import { globelurl, posturl } from "../../api/axios.js";

export default {
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue && this.createOrUp == "up") {
          //获取会员详情
          getMemberById({ id: this.memberId }).then((res) => {
            if (res.status === 200 && res.data.success) {
              // console.log(res.data.result, "会员详情");
              this.cVipform = res.data.result;
              this.creatImageUrl = globelurl + this.cVipform.photoData;
              this.levelId = this.cVipform.levelId; //当前会员等级
              this.cardName = this.levelNameFun(this.levelId).cardName; //当前会员名称
              this.cVipform.honourIds =
                this.cVipform.honourIds == null
                  ? []
                  : this.cVipform.honourIds.split(","); //会员荣誉
              if (this.huixian && this.huixian.length > 0) {
                // 获取用户真实等级id 展示升卡下拉列表
                this.getUpgradeCardList(this.levelId);
                this.huixian.map((itm) => {
                  if (itm.name == "升卡") {
                    // 回显用的（等级下拉选中）
                    this.cVipform.levelId = itm.upgradeLevelId;
                  }
                  if (itm.name == "储值") {
                    this.upbalance = itm.money;
                  }
                });
              } else {
                // 如果之前没有升卡储值操作
                this.getUpgradeCardList(this.levelId);
                this.upbalance = 0;
              }
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      },
    },
  },
  props: {
    value: {
      type: Boolean,
    },
    createOrUp: {
      type: String,
    },
    memberId: {
      type: String,
    },
    huixian: {
      type: Array,
    },
  },
  data() {
    return {
      cVipform: {
        memberCardSn: "",
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        balance: "",
        giveStore: "",
        levelId: "",
        memberDeptId: "",
        honourIds: [],
        remark: "",
      },
      mdSelectList: [],
      groupsSelectList: [],
      honourList: [],
      rulesNull: {},
      rules: {
        memberName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        memberMobile: [
          {
            required: true,
            message: "请填写手机号码",
            trigger: "blur",
          },
          {
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "手机号格式有误",
            trigger: ["blur", "change"],
          },
        ],
        memberBirthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        // memberSfnum: [
        //   {
        //     pattern:
        //       /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        //     message: "身份证号格式有误",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        balance: [
          {
            pattern: /^[0-9]\d*$/,
            message: "储值只能为数字",
            trigger: ["blur", "change"],
          },
        ],
        // levelId: [
        //   {
        //     required: true,
        //     message: "请选择会员等级",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      creatImageUrl: "",
      photoData: "",
      price: 0, //升卡差价
      mdSelectListAll: [], //全部会员等级
      afterLevelIdName: "", //升卡后会员汉字
      cardName: "", //当前会员名称
      levelId: "", //当前会员等级
      upbalance: "", //升卡储值时的储值
    };
  },

  mounted() {
    this.getMembersCardLevelSelect();
    this.getOldDeptForSelect();
    this.getHonourList();
  },
  methods: {
    //获取会员等级下拉
    getMembersCardLevelSelect() {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.mdSelectList = res.data.result;
          this.mdSelectListAll = res.data.result; //保存一份所有会员等级
        }
      });
    },
    // 会员分组下拉
    getOldDeptForSelect() {
      getOldDeptForSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.groupsSelectList = res.data.result;
        }
      });
    },
    // 会员荣誉多选
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.honourList = res.data.result;
        }
      });
    },
    createVipDialogClose() {
      this.$emit("input", false);
      this.$refs["cVipform"].resetFields();
      this.photoData = "";
      this.creatImageUrl = "";
      this.upbalance = "";
    },
    createVip() {
      this.$refs["cVipform"].validate((valid) => {
        if (valid) {
          if (this.createOrUp == "up") {
            this.$emit("input", false);
            this.levelName(); //计算升卡差价
          } else {
            this.addMember();
          }
        } else {
          this.$message.error("请完善会员信息");
          return false;
        }
      });
    },
    creatHandleAvatarSuccess(res, file) {
      this.photoData = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    // 创建会员
    addMember() {
      addMember({
        ...this.cVipform,
        honourIds: this.cVipform.honourIds.toString(),
        photoData: this.photoData,
      }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.createVipDialogClose();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //  获取当前会员卡可升级等级列表
    getUpgradeCardList(levelId) {
      getUpgradeCardList({ levelId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.mdSelectList = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 会员等级换算
    levelName() {
      let beforeLevelIdItem = this.levelNameFun(this.levelId).upgradePrice; // 升级前的会员所需金额
      let afterLevelIdItem = this.levelNameFun(
        this.cVipform.levelId
      ).upgradePrice; //升级后的会员所需金额
      this.price = afterLevelIdItem - beforeLevelIdItem; //升卡后差价
      this.afterLevelIdName = this.levelNameFun(this.cVipform.levelId).cardName; //升卡后名字
      this.$emit(
        "prices",
        this.price, //升卡差价
        this.cVipform.levelId, //升卡后的会员等级id
        this.afterLevelIdName, //声卡后等级
        this.upbalance //储值
      );
    },
    levelNameFun(levelId) {
      let itms = this.mdSelectListAll.filter((item) => {
        if (item.id == levelId) {
          return item;
        }
      });
      return itms[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
  },
};
</script>
<style scoped>
.positionR {
  position: relative;
}
.width70 {
  width: 70%;
}
.ml5 {
  margin-left: 8px;
}
.vipManPhoto {
  position: absolute;
  width: 140px;
  height: 140px;
  top: 0px;
  right: 80px;
}

/* .vipManPhoto img {
  width: 100%;
  height: 100%;
} */
/* .imgup {
  display: flex;
  margin-top: 5px;
  margin-left: -15px;
} */
.gradeNow {
  margin-left: 30px;
  display: flex;
}

.vipnows {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}

.vipnows > div {
  width: 33%;
}
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-top: 20px;
}
.avatar-uploader {
    width: 178px;
  height: 178px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarImport {
  width: 178px;
  height: 178px;
  display: block;
}
.el-checkbox-button__inner {
  border: 1px solid #ccc;
}
</style>

<style>
/* .el-upload {
  border: 1px dashed #d9d9d9;
  margin-top: 20px;
}
.avatar-uploader {
    width: 178px;
  height: 178px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarImport {
  width: 178px;
  height: 178px;
  display: block;
}
.el-checkbox-button__inner {
  border: 1px solid #ccc;
} */
</style>